import script from "./RegionalContacts.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegionalContacts.vue?vue&type=script&setup=true&lang=ts"

import "./RegionalContacts.vue?vue&type=style&index=0&id=d214e42e&lang=scss"

const __exports__ = script;

export default __exports__